import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import React from 'react';
import { Button } from 'reactstrap';
import classNames from 'classnames';
import ResizeDetector from 'react-resize-detector';
var blockClass = 'reveal-btn';

var RevealButton = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(RevealButton, _React$Component);

  function RevealButton(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;

    _defineProperty(_assertThisInitialized(_this), "showContent", function () {
      _this.setState({
        isCollapsed: false
      });

      _this.resizeFill();
    });

    _defineProperty(_assertThisInitialized(_this), "hideContent", function () {
      _this.resetFillDimensions();

      _this.setState({
        isCollapsed: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "resetFillDimensions", function () {
      _this.fill.style.width = '';
      _this.fill.style.height = '';
    });

    _defineProperty(_assertThisInitialized(_this), "setMinFillDimensions", function () {
      _this.fill.style.minWidth = _this.button.offsetWidth + 'px';
      _this.fill.style.minHeight = _this.button.offsetHeight + 'px';
    });

    _defineProperty(_assertThisInitialized(_this), "resizeFill", function () {
      _this.fill.style.width = _this.props.isFullWidth ? '100%' : _this.content.offsetWidth + 'px';
      _this.fill.style.height = _this.content.offsetHeight + 'px';
    });

    _this.state = {
      isCollapsed: props.isCollapsed
    };
    return _this;
  }

  var _proto = RevealButton.prototype;

  _proto.render = function render() {
    var _this2 = this;

    var _this$props = this.props,
        className = _this$props.className,
        buttonClass = _this$props.buttonClass,
        contentClass = _this$props.contentClass,
        closeClass = _this$props.closeClass,
        id = _this$props.id,
        buttonText = _this$props.buttonText,
        anchorPosition = _this$props.anchorPosition,
        icon = _this$props.icon,
        size = _this$props.size,
        color = _this$props.color,
        isFullWidth = _this$props.isFullWidth,
        isFloating = _this$props.isFloating,
        children = _this$props.children;
    var isCollapsed = this.state.isCollapsed;
    var classes = classNames(blockClass, size ? blockClass + "--" + size : '', anchorPosition ? blockClass + "--" + anchorPosition : '', isFullWidth ? blockClass + "--full-width" : '', isFloating ? blockClass + "--floating" : '', !isCollapsed ? blockClass + "--isOpen" : '', className);
    var buttonClasses = classNames(blockClass + "__btn", buttonClass);
    var fillClasses = classNames(blockClass + "__fill", color ? "bg-" + color : '');
    var contentClasses = classNames(blockClass + "__content", contentClass);
    var closeClasses = classNames(blockClass + "__close", closeClass);
    var buttonIcon = '';

    if (icon === 'arrow') {
      buttonIcon = /*#__PURE__*/React.createElement("span", {
        className: "arrow-angle " + (isCollapsed ? 'arrow-angle--up' : 'arrow-angle--down')
      });
    } else if (icon === 'comment') {
      buttonIcon = /*#__PURE__*/React.createElement("svg", {
        "aria-hidden": "true",
        role: "img",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 512",
        className: "reveal-btn__comment-icon"
      }, /*#__PURE__*/React.createElement("path", {
        d: "m256,33c-141.4,0 -256,93.1 -256,208c0,47.6 19.9,91.2 52.9,126.3c-14.9,39.4 -45.9,72.8 -46.4,73.2c-6.6,7 -8.4,17.2 -4.6,26s12.5,14.5 22.1,14.5c61.5,0 110,-25.7 139.1,-46.3c28.9,9.1 60.1,14.3 92.9,14.3c141.4,0 256,-93.1 256,-208s-114.6,-208 -256,-208zm0,368c-26.7,0 -53.1,-4.1 -78.4,-12.1l-22.7,-7.2l-19.5,13.8c-14.3,10.1 -33.9,21.4 -57.5,29c7.3,-12.1 14.4,-25.7 19.9,-40.2l10.6,-28.1l-20.6,-21.8c-18.1,-19.3 -39.8,-51.2 -39.8,-93.4c0,-88.2 93.3,-160 208,-160s208,71.8 208,160s-93.3,160 -208,160z",
        fill: "currentColor"
      }), /*#__PURE__*/React.createElement("circle", {
        cx: "144",
        cy: "240.5",
        fill: "currentColor",
        r: "31.80243"
      }), /*#__PURE__*/React.createElement("circle", {
        cx: "255.5",
        cy: "240.5",
        fill: "currentColor",
        r: "31.80243"
      }), /*#__PURE__*/React.createElement("circle", {
        cx: "367.5",
        cy: "240.5",
        fill: "currentColor",
        r: "31.80243"
      }));
    } else {
      buttonIcon = icon;
    }

    if (buttonText && children) {
      return /*#__PURE__*/React.createElement("div", {
        className: classes
      }, /*#__PURE__*/React.createElement(Button, {
        className: buttonClasses,
        color: color,
        size: size,
        "aria-expanded": !isCollapsed,
        "aria-controls": id,
        onClick: isCollapsed ? this.showContent : this.hideContent,
        innerRef: function innerRef(ref) {
          return _this2.button = ref;
        }
      }, buttonText, buttonIcon && /*#__PURE__*/React.createElement("span", {
        className: blockClass + "__icon"
      }, buttonIcon), /*#__PURE__*/React.createElement(ResizeDetector, {
        handleWidth: true,
        handleHeight: true,
        onResize: isCollapsed ? this.setMinFillDimensions : null
      })), /*#__PURE__*/React.createElement("div", {
        className: fillClasses,
        ref: function ref(_ref) {
          return _this2.fill = _ref;
        }
      }), /*#__PURE__*/React.createElement("div", {
        id: id,
        className: contentClasses,
        ref: function ref(_ref2) {
          return _this2.content = _ref2;
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: blockClass + "__content-inner"
      }, children), /*#__PURE__*/React.createElement(Button, {
        className: closeClasses,
        disabled: isCollapsed,
        close: true,
        size: size,
        onClick: this.hideContent
      }), /*#__PURE__*/React.createElement(ResizeDetector, {
        handleWidth: true,
        handleHeight: true,
        onResize: !isCollapsed ? this.resizeFill : null
      })));
    }

    return null;
  };

  return RevealButton;
}(React.Component);

export { RevealButton as default };
RevealButton.defaultProps = {
  id: 'reveal1',
  buttonText: 'Text Us!',
  anchorPosition: 'top-left',
  color: 'secondary',
  isCollapsed: true,
  icon: 'arrow'
};